<template>
  <vue-date-picker
    v-bind="context?.attrs"
    v-model="dateValue"
    model-type="iso"
    :config="{ monthChangeOnScroll: false }"
    :time-config
    arrow-navigation
    :text-input
    :placeholder
    :aria-labels="{ input: context?.label || 'Date Picker input' }"
    :input-attrs="{
      id: context?.id,
      name: context?.node?.name,
      hideInputIcon: true,
    }"
    :formats="{ input: inputFormats }"
  />
</template>

<script setup>
import { VueDatePicker } from "@vuepic/vue-datepicker";
import { computed, ref, watch } from "vue";
const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
});

const disableTimePicker =
  props.context?.attrs["disable-time-picker"] !== undefined;
const inputFormats = disableTimePicker
  ? "MMMM dd, yyyy"
  : "MMMM dd, yyyy hh:mm a";

const placeholder = computed(() => {
  if (props.context?.attrs?.placeholder) {
    return props.context?.attrs?.placeholder;
  } else if (disableTimePicker) {
    return "MM/DD/YYYY";
  } else {
    return "MM/DD/YYYY, HH:MM AM/PM";
  }
});
const textInput = props.context?.attrs["disable-text-input"] ? false : true;
const timeConfig = computed(() => ({
  is24: false,
  timePickerInline: true,
  enableTimePicker: disableTimePicker ? false : true,
}));

watch(
  () => props.context.value,
  (newValue) => {
    if (newValue !== dateValue.value) {
      dateValue.value = newValue;
    }
  },
);
const dateValue = ref(props.context.value || "");
watch(dateValue, () => {
  props.context.node.input(dateValue.value);
});
</script>
<style lang="css">
.dp__menu {
  background: white;
}
</style>
